import { Inject, Injectable, LOCALE_ID } from "@angular/core";

import {FamilyId} from "../models/item.mjs";
import { DbLocale, FAMILY_DB, localeIdToDbLocale } from "./hfest-db.mjs";

@Injectable()
export class HfestFamiliesDb {
  readonly #locale: DbLocale;
  readonly #familyNames: ReadonlyMap<FamilyId, string>;

  constructor(@Inject(LOCALE_ID) localeId: string) {
    this.#locale = localeIdToDbLocale(localeId);
    this.#familyNames = new Map(
      FAMILY_DB.map(f => [f.id, f.name[this.#locale]]),
    );
  }

  get familyNames(): ReadonlyMap<FamilyId, string> {
    return this.#familyNames;
  }

  getFamilyName(familyId: FamilyId): string | undefined {
    return this.#familyNames.get(familyId);
  }
}
